import { useContext } from 'react';
import { PromptTemplatesContext } from '../context/entity-collections';
import { filter, sortBy } from 'lodash';
export var usePromptTemplates = function () {
  return useContext(PromptTemplatesContext);
};
export var useSelectablePromptTemplates = function () {
  var templates = usePromptTemplates();
  return sortBy(filter(templates, function (template) {
    return !template.hideInTemplateList;
  }), 'orderNumber');
};